"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var LocaleSwitcherComponent = (function (_super) {
    __extends(LocaleSwitcherComponent, _super);
    function LocaleSwitcherComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LocaleSwitcherComponent.prototype, "locales", {
        get: function () {
            var _this = this;
            var locales = [
                { value: 'en', text: this.$i18n.tc('locales.en') },
                { value: 'fr', text: this.$i18n.tc('locales.fr') },
                { value: 'es', text: this.$i18n.tc('locales.es') },
                { value: 'it', text: this.$i18n.tc('locales.it') }
            ];
            return locales.filter(function (locale) {
                return locale.value !== _this.$i18n.locale;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocaleSwitcherComponent.prototype, "currentLocaleText", {
        get: function () {
            return this.$i18n.tc('locales.' + this.$i18n.locale);
        },
        enumerable: false,
        configurable: true
    });
    LocaleSwitcherComponent.prototype.setLocale = function (locale) {
        this.$i18n.setLocale(locale);
    };
    LocaleSwitcherComponent = __decorate([
        vue_class_component_1.default
    ], LocaleSwitcherComponent);
    return LocaleSwitcherComponent;
}(vue_1.default));
exports.default = LocaleSwitcherComponent;
